<template>
    <div class="systemView">
      <div class="systemBody">
        <div class="top">
          <div class="topbg top_1">
            <div class="toptxt">
              <div class="toptxtNum">{{ totalElderlyCount }}</div>
              <div class="toptxtTxt">服务老人总数</div>
            </div>
            <div class="topimg">
              <img src="./img/1.png" alt="" />
            </div>
          </div>
          <div class="topbg top_2">
            <div class="toptxt">
              <div class="toptxtNum">{{averageElderlyAge  }}</div>
              <div class="toptxtTxt">老人平均年龄</div>
            </div>
            <div class="topimg">
              <img src="./img/2.png" alt="" />
            </div>
          </div>
          <div class="topbg top_3">
            <div class="toptxt">
              <div class="toptxtNum">{{ totalHomeCount }}</div>
              <div class="toptxtTxt">机构数量</div>
            </div>
            <div class="topimg">
              <img src="./img/3.png" alt="" />
            </div>
          </div>
          <div class="topbg top_4">
            <div class="toptxt">
              <div class="toptxtNum">{{ deviceCount}}</div>
              <div class="toptxtTxt">智能设备数量</div>
            </div>
            <div class="topimg">
              <img src="./img/4.png" alt="" />
            </div>
          </div>
        </div>
  
        <el-row gutter="24" style="margin-top: 10px">
          <!-- 通知 -->
          <el-col span="6">
            <div class="itemContain companyInfoItem">
              <div class="companyInfoItemtxt">老人年龄分布图</div>
              <div id="oldePeopleAge" :style="'height:' + echartsHeight + 'px'"></div>
            </div>
          </el-col>
          <el-col span="12">
            <div class="itemContain companyInfoItem">
              <div class="companyInfoItemtxt">养老机构信息</div>
              <el-table
                :data="nursingHomeInfoList"
                ref="table"
                :height="tableHeight + 'px'"
                border
                style="width: 100%;margin-top: 5px;"
              >
                <el-table-column type="index" width="50" label="序号" />
                <el-table-column prop="nursingHomeName" label="养老院名称" />
                <el-table-column prop="roomCount" label="房间数量"  />
                <el-table-column prop="bedCount" label="床位数量"  />
                <el-table-column prop="emptyBedCount" label="空闲数量"  />
                <el-table-column prop="elderlyCount" label="老人数量" />
              </el-table>
            </div>
          </el-col>
          <el-col span="6">
            <div class="itemContain companyInfoItem">
              <div class="companyInfoItemtxt">上门服务营收情况</div>
              <div id="goRoomServe" :style="'height:' + echartsHeight + 'px'"></div>
            </div>
          </el-col>
          <el-col span="6">
            <div class="itemContain companyInfoItem">
              <div class="companyInfoItemtxt">上门服务项目排行</div>
              <div id="goRoomRank" :style="'height:' + echartsHeight + 'px'"></div>
            </div>
          </el-col>
          <el-col span="12">
            <div class="itemContain companyInfoItem">
              <div class="companyInfoItemtxt">老人告警信息</div>
              <el-table
                :data="elderlyAlarmInfoList"
                ref="table2"
                :height="tableHeight + 'px'"
                border
                style="width: 100%;margin-top: 5px;"
              >
                <el-table-column type="index" width="50" label="序号" />
                <el-table-column prop="alarmName" label="报警名称" />
                <el-table-column prop="alarmType" label="报警类型"  />
                <el-table-column prop="alarmTime" label="发生时间"  />
                <el-table-column prop="elderlyName" label="老人姓名" />
                <el-table-column prop="locationName" label="发生位置" />
              </el-table>
            </div>
          </el-col>
         
          <el-col span="6">
            <div class="itemContain companyInfoItem">
              <div class="companyInfoItemtxt">商城营收情况</div>
              <div id="shopAccountInfo" :style="'height:' + echartsHeight + 'px'"></div>
            </div>
          </el-col>
         
        </el-row>
      </div>
    </div>
  </template>
  <script>
  import { opt_chart } from './echartOption';
  import {getIndexInfo} from "@/api/nursingHome/index"
  export default {
    data() {
      return {
        height: '',
        echartsHeight: '',
        echartsParkHeight: '',
        tableHeight: '',
        tableData: [
          {
            date: '人流密度大',
            name: '2',
            address: '2023-03-25 16:00',
          },
          {
            date: '交通堵塞',
            name: '1',
            address: '2023-03-25 16:01',
          },
          {
            date: '配电房报警',
            name: '3',
            address: '2023-03-25 13:00',
          },
          {
            date: '空调冷水异常',
            name: '3',
            address: '2023-03-25 13:00',
          },
          {
            date: 'A区门禁2f非法侵入',
            name: '2',
            address: '2023-03-25 14:33',
          },
          {
            date: '交通堵塞',
            name: '1',
            address: '2023-03-25 16:05',
          },
          {
            date: '电网瘫痪',
            name: '1',
            address: '2023-03-25 16:31',
          },
          {
            date: '北区空调漏水',
            name: '1',
            address: '2023-03-25 17:31',
          },
          {
            date: 'B区门禁2f非法侵入',
            name: '1',
            address: '2023-03-25 17:33',
          },
          {
            date: 'C区门禁3E非法侵入',
            name: '1',
            address: '2023-03-25 17:33',
          },
          {
            date: 'B区电网瘫痪',
            name: '1',
            address: '2023-03-25 17:40',
          },
          {
            date: '配电房报警',
            name: '3',
            address: '2023-03-25 18:00',
          },
          {
            date: 'A区空调温度异常',
            name: '3',
            address: '2023-03-25 18:01',
          },
          {
            date: 'C区交通堵塞',
            name: '3',
            address: '2023-03-25 18:04',
          },
          {
            date: 'D区配电房报警',
            name: '1',
            address: '2023-03-25 18:07',
          },
          
        ],
        elderlyAgeDistribution:{},
        lineChartDataShow:{},
        nursingHomeInfoList:[],
        outOrderRankingInfo:{},
        elderlyAlarmInfoList:[],
        totalElderlyCount:0,
        averageElderlyAge:0,
        totalHomeCount:0,
        deviceCount:0,
        mallRevenueLineChartDataShow:{},
      };
    },
    mounted() {
      this.height = this.bodyHeight - 64;
      this.echartsHeight = this.height * 0.3;
      this.echartsParkHeight = this.echartsHeight - 100;
      this.tableHeight = this.echartsHeight - 5;
    
      this.initData()
      setTimeout(() => {
        this.initCompanyInfo();
      
        this.initFinancialOverviewInfo();
        this.initOrderInfo();
      
        this.initEnergyConsumptionInfo();
        this.infinitScroll("table");
        this.infinitScroll("table2");
      });
    },
    methods: {
      initData(){
        getIndexInfo().then(res=>{
          this.totalElderlyCount=res.data.elderlyInfo.totalElderlyCount
          this.averageElderlyAge=res.data.elderlyInfo.averageElderlyAge
          this.totalHomeCount=res.data.nursingHomeInfo.totalHomeCount
          this.deviceCount=res.data.smartDeviceInfo.deviceCount
          this.elderlyAgeDistribution = res.data.elderlyInfo.elderlyAgeDistribution

          this.initCompanyInfo()
          this.nursingHomeInfoList = res.data.nursingHomeInfo.nursingHomeInfoList
          this.elderlyAlarmInfoList = res.data.smartDeviceInfo.elderlyAlarmInfoList
          this.lineChartDataShow = res.data.outOrderInfo.lineChartDataShow
          this.initOrderInfo()
          this.outOrderRankingInfo = res.data.outOrderInfo.outOrderRankingInfo
          this.initFinancialOverviewInfo()

          this.mallRevenueLineChartDataShow = res.data.mallRevenueLineChartDataShow
          this.initEnergyConsumptionInfo()
        })
      },
      initCompanyInfo() {

        let chartDom = document.getElementById('oldePeopleAge');
        let myChart = echarts.init(chartDom);
        opt_chart.companyInfoOption.series[0].data = this.elderlyAgeDistribution
        myChart.setOption(opt_chart.companyInfoOption);
      },
      initParkInfo() {
        let chartDom = document.getElementById('parkInfo');
        let myChart = echarts.init(chartDom);
  
        myChart.setOption(opt_chart.parkInfoOption);
      },
      initFinancialOverviewInfo() {
        let chartDom = document.getElementById('goRoomRank');
        let myChart = echarts.init(chartDom);
        if (JSON.stringify(this.outOrderRankingInfo) != '{}'){
          opt_chart.goRoomRankOption.xAxis.data=this.outOrderRankingInfo.xAxis
          opt_chart.goRoomRankOption.yAxis.data=this.outOrderRankingInfo.yaxis
          this.outOrderRankingInfo.series.forEach((item,index)=>{
           item. type= 'bar'
           item.stack= 'Y'
          })
          opt_chart.goRoomRankOption.series=this.outOrderRankingInfo.series
          myChart.setOption(opt_chart.goRoomRankOption);
        }
       
      },
      initOrderInfo() {
        let chartDom = document.getElementById('goRoomServe');
        let myChart = echarts.init(chartDom);
        if (JSON.stringify(this.lineChartDataShow) != '{}'){
          opt_chart.goRoomServeOption.xAxis.data=this.lineChartDataShow.xaxis
          opt_chart.goRoomServeOption.series=this.lineChartDataShow.lineChartList
        }
        myChart.setOption(opt_chart.goRoomServeOption);
      },
      initDeviceInfo() {
        let chartDom = document.getElementById('deviceInfo');
        let myChart = echarts.init(chartDom);
  
        myChart.setOption(opt_chart.deviceInfoOption);
      },
      initEnergyConsumptionInfo() {
        let chartDom = document.getElementById('shopAccountInfo');
        let myChart = echarts.init(chartDom);
        if (JSON.stringify(this.mallRevenueLineChartDataShow) != '{}'){
          opt_chart.shopAccountInfoOption.xAxis.data=this.mallRevenueLineChartDataShow.xaxis
          opt_chart.shopAccountInfoOption.series=this.mallRevenueLineChartDataShow.lineChartList
        }
        myChart.setOption(opt_chart.shopAccountInfoOption);
      },
      infinitScroll(name) {
        // 拿到表格挂载后的真实DOM
        const table = this.$refs[name];
        // 拿到表格中承载数据的div元素
        const divData = table.bodyWrapper;
        divData.onmouseover = function() {
          clearInterval(t);
        }; //鼠标移入，停止滚动
        divData.onmouseout = function() {
          start();
        }; //鼠标移出，继续滚动
  
        // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每1秒移动20像素)
        let t;
        function start() {
          // 数据少于表格高度停止滚动
  
          if (divData.clientHeight >= divData.scrollHeight) {
           
            return;
          }
          t = setInterval(() => {
            // 元素自增距离顶部1像素
            divData.scrollTop += 1;
            // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
            if (divData.scrollHeight-divData.clientHeight- divData.scrollTop  <=5) {  
              // 重置table距离顶部距离
            
              divData.scrollTop = 0;
            }else{
             
            }
          }, 50);
        }
        start();
      },
    },
  };
  </script>
  <style scoped lang="scss">
  ::v-deep .el-table__body-wrapper{
    overflow-y: hidden;
  }
  .parkInfomation {
    margin-top: 10px;
    width: 100%;
    display: flex;
    height: 50px;
    .parkInfoTxtArea {
      width: 50%;
      text-align: center;
      .parkName {
        width: 100%;
      }
      .parkNum {
        font-size: 20px;
        font-weight: 600;
        width: 100%;
      }
    }
  }
  .itemContain {
    border: 10px solid #f5f6f8;
  }
  .companyInfoItem {
    .companyInfoItemtxt {
      margin-top: 10px;
      margin-left: 10px;
      font-size: 24px;
      font-weight: 700;
    }
    .parkBottom {
      height: 40px;
      width: 100%;
      text-align: center;
      vertical-align: middle;
    }
  }
  #companyInfo {
    width: 100%;
    height: 100%;
  }
  #deviceInfo {
    width: 100%;
    height: 100%;
  }
  #shopAccountInfo {
    width: 100%;
    height: 100%;
  }
  #parkInfo {
    width: 100%;
    height: 100%;
  }
  #goRoomRank {
    width: 100%;
    height: 100%;
  }
  #goRoomServe {
    width: 100%;
    height: 100%;
  }
  
  .top {
    border: 10px solid #f5f6f8;
    height: calc(12%);
    width: 100%;
    background: #f5f6f8;
    display: inline-grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 20px;
    grid-template-rows: 100%;
  }
  .topbg {
    background: #fff;
    display: flex;
    box-sizing: border-box;
  }
  .toptxt {
    width: 70%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    text-align: center;
    .toptxtNum {
      width: 100%;
      font-size: 24px;
      font-weight: 700;
    }
    .toptxtTxt {
      font-size: 16px;
      width: 100%;
    }
  }
  .topimg {
    width: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      aspect-ratio: 1/1;
      height: calc(50%);
    }
  }
  .systemView {
    background: #fff;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
  }
  .systemBody {
    height: 100%;
    width: 100%;
    padding: 8px 10px 8px 10px;
    box-sizing: border-box;
  }
  </style>
  